// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles-module--nav--Xug1A","post":"styles-module--post--1DE3s","img":"styles-module--img--1Dkly","desc":"styles-module--desc--1KP3I","title":"styles-module--title--UAb9V"};